import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";

const ReservationRoomDetails = ({paxCount}) => {
  return (
    <Grid container rowSpacing={1} mt={5} ml={7}>
      <Grid size={6}>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item size={6}>
            <Typography variant="body1" m={1}>
              Total Pax:
            </Typography>
          </Grid>
          <Grid item size={6}>
            <Typography variant="h6" m={1}>
              {paxCount}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReservationRoomDetails;
